import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getHallViewAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/hallView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class HallView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
    };

    this.getVendorAuditTrackerList = this.getVendorAuditTrackerList.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorAuditTrackerList();
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getVendorAuditTrackerList() {
    const {
      zoneId,
      ExhibitorName,
      VendorName,
      StatusID,
      hallId,
      ExhRegNo,
      serviceId,
    } = this.state;

    this.setState({ isLoading: true });

    try {
      const data = await this.props.getHallViewAuditTrackerList_action(
        hallId,
        "",
        ExhRegNo,
        ExhibitorName,
        VendorName,
        StatusID,
        zoneId,
        serviceId
      );

      // Handle API error
      if (data.error === 1) {
        toastError(data.error);
        return;
      }

      const sampleData = [];

      await data.data.map((item) => {
        sampleData.push({
          Service: item.ServiceName,
          CompanyName: item.CompanyName,
          VendorName: item.VendorName,
          MobileNo: item.MobileNo,
          EmailID: item.PrimaryEmail,
          HallID: item.HallID,
          HallName: item.HallName,
          HallStatus: item.HallStatus,
          IsServiceAllocated: item.IsServiceAllocated,
        });
      });
      console.log("this.transformData(sampleData)2-->", sampleData);
      console.log(
        "this.transformData(sampleData)-->",
        this.transformData(sampleData)
      );
      const { halls, grid } = this.transformData(sampleData);
      this.setState({ halls, grid });
    } catch (err) {
      console.error("Error in getVendorAuditTrackerList:", err);
      toastError(
        "Something went wrong while fetching Hall Manager Work Updation list."
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  transformData(apiData) {
    const halls = [...new Set(apiData.map((item) => item.HallName))];
    const services = [...new Set(apiData.map((item) => item.Service))];

    const grid = services.map((service) => {
      const row = { service };
      halls.forEach((hall) => {
        const records = apiData.filter(
          (d) => d.Service === service && d.HallName === hall
        );
        row[hall] = records.length > 0 ? records : [];
      });
      return row;
    });

    return { halls, grid };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorAuditTrackerList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  renderWorkUpdationList() {
    const { halls, grid } = this.state;

    return (
      <div className="row m-0">
      <div class="table-responsive sticky-table-wrapper border-bottom service-list-grid-1 mx-2 p-0">
        <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 me-2">
          <thead class="table-light">
            <tr>
              <th
                className="text-center">
                Services
              </th>
              {halls.map((hall, index) => (
                <th
                  key={index}
                  className="text-center">
                  {hall}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {grid.map((row, i) => (
              <tr key={i}>
                {/* Service column with icons */}
                <td className="text-center align-middle fw-semibold">
                  {row.service}
                </td>

                {/* Hall data cells */}
                {halls.map((hall, j) => {
                  const vendors = row[hall];
                  return (
                    <td
                      key={j}
                      className={
                        (vendors && vendors.length > 0)
                          ? "p-2 align-top"
                          : "text-center align-middle fst-italic text-muted"
                      }
                    >
                      {(!vendors || vendors.length === 0) && (
                        'Not Allocated'
                      )}
                      {vendors &&
                        vendors.map((v, k) => (
                          <div
                            key={k}
                            // className="mb-3 pb-2 border-bottom border-gray-200 last:border-0"
                            className="mb-3 pb-2"
                          >
                            <div>
                              <i className="ri-building-4-line me-1 grid-icon "></i>{" "}
                              {v.CompanyName}
                            </div>
                            <div>
                              <i className="ri-user-3-line grid-icon"></i>{" "}
                              {v.VendorName}
                            </div>
                            <div>
                              <i className="ri-phone-line grid-icon"></i>{" "}
                              {v.MobileNo}
                            </div>
                            <div>
                              <i className="ri-mail-line grid-icon"></i>{" "}
                              {v.EmailID}
                            </div>
                            <div>
                              <span className={`badge bg-aqua text-white fw-normal ${v.HallStatus == 'Completed' ? 'completed' : v.HallStatus == 'Pending' ? 'pending' : v.HallStatus == 'InProgress' ? 'inprogress' : 'delayed'}`}>
                                {v.HallStatus == 'Completed' ? 'Completed' : v.HallStatus == 'Pending' ? 'Pending' : v.HallStatus == 'inprogress' ? 'inprogress' : 'In Progress'}
                              </span>
                            </div>
                          </div>
                        ))}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" class={RoleID == 16 ? "px-3" : "px-1"}>
              <section class="section" style={{ padding: 0 }}>
                <div class="row m-0 p-0">
                  <div class="container-fluid pt-2 pb-0">
                    <div class="d-flex align-items-end w-100">
                      <div class="flex-fill me-2">
                        <label class="ms-1">Hall</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={hallId}
                          onChange={(e) =>
                            this.setState({ hallId: e.target.value }, () => {
                              if (e.target.value != "") {
                                this.getFillList(
                                  HallZoneActionId,
                                  this.state.exhibitionID,
                                  e.target.value,
                                  "",
                                  "",
                                  "",
                                  false
                                );
                              } else {
                                this.setState({ zoneList: [] });
                              }
                            })
                          }
                        >
                          <option value={""}>Select</option>
                          {hallList.length > 0 &&
                            hallList.map((data) => (
                              <option key={data.HallId} value={data.HallId}>
                                {data.HallName}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="flex-fill me-2">
                        <label class="ms-1">Zone</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={zoneId}
                          onChange={(e) =>
                            this.setState({ zoneId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {zoneList.length > 0 &&
                            zoneList.map((data) => (
                              <option
                                key={data.HallZoneMappingID}
                                value={data.HallZoneMappingID}
                              >
                                {data.Zone}
                              </option>
                            ))}
                        </select>
                      </div>

                      {/* <div class="flex-fill me-2">
                        <label class="ms-1l">Exhibitor Reg. No.</label>
                        <input
                          type="text"
                          class="form-control form-control-sm w-100"
                          value={ExhRegNo}
                          onChange={(e) =>
                            this.setState({ ExhRegNo: e.target.value })
                          }
                          maxLength={100}
                        />
                      </div>

                      <div class="flex-fill me-2">
                        <label class="ms-1">Exhibitor Company</label>
                        <input
                          type="text"
                          class="form-control form-control-sm w-100"
                          value={ExhibitorName}
                          onChange={(e) =>
                            this.setState({ ExhibitorName: e.target.value })
                          }
                          maxLength={100}
                        />
                      </div> */}

                      <div class="flex-fill me-2">
                        <label class="ms-1">Service Partner Company</label>
                        <input
                          type="text"
                          class="form-control form-control-sm w-100"
                          value={VendorName}
                          onChange={(e) =>
                            this.setState({ VendorName: e.target.value })
                          }
                          maxLength={100}
                        />
                      </div>

                      <div class="flex-fill me-2">
                        <label class="ms-1">Services</label>
                        <select
                          className="form-control form-control-sm w-100"
                          id="roledb"
                          value={serviceId}
                          onChange={(e) =>
                            this.setState({ serviceId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {serviceList.length > 0 &&
                            serviceList.map((data) => (
                              <option
                                key={data.ServiceID}
                                value={data.ServiceID}
                              >
                                {data.Name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="me-2">
                        <button
                          class="btn btn-aqua"
                          onClick={() => this.getVendorAuditTrackerList()}
                        >
                          Search
                        </button>
                      </div>

                      <div>
                        <button
                          class="btn btn-gray"
                          onClick={() => this.handleClear()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                    <div className="legend-parent">
                      <div className="legend d-flex align-items-center ms-2 w-100">
                        <span>
                          <div className="legend-box pending" />
                          Pending
                        </span>
                        <span>
                          <div className="legend-box inprogress" />
                          In Progress
                        </span>
                        <span>
                          <div className="legend-box completed" />
                          Completed
                        </span>
                        <span>
                          <div className="legend-box delayed" />
                          Delayed
                        </span>
                      </div>
                    </div>
                  </div>

                  {this.renderWorkUpdationList()}

                  {/* <!-- Hall Script --> */}
                </div>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getHallViewAuditTrackerList_action,
  })(HallView)
);
